import React, { useEffect, useState, useRef } from 'react'
import "./index.scss";
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from "react-redux";
import { RouteComponentProps } from 'react-router-dom';
import { showMenuTabs, showFooter } from '../../ducks/redux/actions/userChoices';
import Button from '../../storybook/Button';
import mobileChevronleft from "../../assets/img/mobileChevronleft.png";
import HeaderJourney from "../../storybook/Header/HeaderJourney";
import { detectMobile } from "../../utils/formatting";
import Message from "../../storybook/Message";
import { checkPayPointHealth } from "../../api";
import { trackEvent, trackException } from "../../appInsights/TelemetryService";

interface PaymentGatewayProps extends RouteComponentProps<any> {
}

const PaymentGateway: React.FC<PaymentGatewayProps> = (props) => {
    const iframeRef = useRef<HTMLIFrameElement | null>(null);
    const [healthCheckPassed, setHealthCheckPassed] = useState(false);
    const paymentGatewayUrl: string = process.env.REACT_APP_PAYPOINT_URL || '';
    const _channel = process.env.REACT_APP_X_CHANNEL_IDENTIFIER;
    const _customerId = localStorage.getItem("customerId") || "";
    const _corelationId = localStorage.getItem("corelationId") || "";
    const _sessionId = localStorage.getItem("sessionId") || "";
    const dispatch = useDispatch();
    const balance = Number(useSelector(
        (state: any) => state.userChoicesReducer?.OtherBalance)
    );
    const isMobile = detectMobile();
    const accountnumber = (useSelector(
        (state: any) => state.userChoicesReducer?.accountnumber)
    );
    const { t } = useTranslation()
    const [messageAlert, setMessageAlert] = React.useState(false);

    useEffect(() => {
        const runHealthCheck = async () => {
            try {
                trackEvent(
                    window.location.pathname + " - Paypoint HealthCheck Started",
                    process.env.REACT_APP_X_CHANNEL_IDENTIFIER,
                    _customerId,
                    _corelationId,
                    _sessionId
                );
                const response = await checkPayPointHealth();
                if (response?.status.toLowerCase() === "healthy")
                {
                    trackEvent(
                        window.location.pathname + " - Paypoint HealthCheck Success",
                        process.env.REACT_APP_X_CHANNEL_IDENTIFIER,
                        _customerId,
                        _corelationId,
                        _sessionId
                    );
                    setHealthCheckPassed(true);
                } else {
                    trackEvent(
                        window.location.pathname + " - Paypoint HealthCheck Failed",
                        process.env.REACT_APP_X_CHANNEL_IDENTIFIER,
                        _customerId,
                        _corelationId,
                        _sessionId
                    );
                    props.history.push("/paymentfailure");
                }
            } catch (error: any) {
                trackException(
                    error,
                    _channel,
                    _customerId,
                    _corelationId,
                    _sessionId
                );
                props.history.push("/paymentfailure");
            }
        };
        runHealthCheck();
    }, []);

    useEffect(() => {
        if (!healthCheckPassed || !iframeRef.current) return;
        try {
            const Payment = Number(balance.toString().replace(/£/g, ''))
            const liveBalancevalue = Payment.toFixed(2);
            iframeRef.current.src =
                `${paymentGatewayUrl}&Amount=${liveBalancevalue}&AccountNumber=${accountnumber}`;
            trackEvent(
                window.location.pathname + " - Paypoint Iframe_Loaded",
                process.env.REACT_APP_X_CHANNEL_IDENTIFIER,
                _customerId,
                _corelationId,
                _sessionId
            );
        } catch (error: any) {
            trackException(
                error,
                _channel,
                _customerId,
                _corelationId,
                _sessionId
            );
            props.history.push("/paymentfailure");
        }
    }, [healthCheckPassed, balance, accountnumber]);

    useEffect(() => {
        dispatch(showMenuTabs(false));
        dispatch(showFooter(false));
    }, [])

    const backButtonHandler = () => {
        props.history.push("/viewaccount");
    };

    function onErrorEvent(event: any) {
        props.history.push("/paymentfailure");
    }
    const openDialer = () => {
        window.open("tel:" + t("phone_no"));
    }
    const returnToHome = () => {
        props.history.push("/customer360View");
    };
    return (
        <div className="pg-flex-container">
            <HeaderJourney />
            <div className="pg-scroll-content">
                {!messageAlert ? (
                    <div id="iframe-Payment" className="container-fluid parent-footer p-0">
                        <div className="">
                            <div className={isMobile ? "Payment-scroll" : "mt-24 Payment-scroll"}>
                                    <iframe
                                        ref={iframeRef}
                                        id="paypointPayment"
                                        className="iframe-width"
                                        height={isMobile ? "1540px" : "1260px"}
                                        allow="payment"
                                        scrolling={isMobile ? "no" : "auto"}
                                        title="peabody-iframe"
                                        onError={onErrorEvent}
                                    ></iframe>
                            </div>
                        </div>
                    </div>
                ) : isMobile ? (
                    <div>
                        <Message className="error-msg">
                            {t("payment_Message_Api_Failure")} <span className='underline' onKeyDown={openDialer} onClick={openDialer}>{t("phone_no")}</span><br /><br />
                            <span onKeyDown={returnToHome} onClick={returnToHome} className="underline cursor-pointer">{t("Return_to_Home")}</span>
                        </Message>
                    </div>
                ) : (
                    <div>
                        <Message className="error-msg">
                            {t("payment_Message_Api_Failure")} <span>{t("phone_no")}</span><br /><br />
                            <span onKeyDown={returnToHome} onClick={returnToHome} className="underline cursor-pointer">{t("Return_to_Home")}</span>
                        </Message>
                    </div>
                )}
            </div>
            {/* Sticky Footer */}
            <footer className={isMobile ? "" : "pg-sticky-footer"}>
                <div className="col-md-12 marginTop-auto payment-bordernone">
                    <div className="row m-0 footer-actionbtn col-pay">
                        <div className="btn-top padding-repair mb-24">
                            <span className="payment-backbtn">
                                <Button
                                    data-testid="back-button"
                                    onClick={backButtonHandler}
                                    className="secondary-ghost-btn"
                                >
                                    {t("Go_To_Account")}
                                </Button>
                            </span>
                            <span className="payment-backarrow">
                                <img src={mobileChevronleft} onClick={backButtonHandler} onKeyDown={backButtonHandler} alt="Back" />
                            </span>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    )
}

export default PaymentGateway;